/**
 * Created by Xiaotao.Nie on 24/01/2018.
 * All right reserved
 * IF you have any question please email onlythen@yeah.net
 */

export function mapToGrad (num) { // 给定次数, 选择一个合适的数字
  switch (num) {
    case 0:
      return 0
    case 1:
      return 1
    case 2:
    case 3:
      return 2
    case 4:
    case 5:
      return 3
    default:
      return 4
  }
}

export const deepCopy = function (o) {
  if (o instanceof Array) {
    let n = []
    for (let i = 0; i < o.length; ++i) {
      n[i] = deepCopy(o[i])
    }
    return n
  } else if (o instanceof Object) {
    let n = {}
    for (let i in o) {
      n[i] = deepCopy(o[i])
    }
    return n
  } else {
    return o
  }
}

/**
 * 滚动函数，可以向上滚动或者向下滚动
 * 目前该函数没有经过充分测试，可能存在一些问题
 * */
export function scrollTo (tarY) { // tarY 即滑动条顶端 距离页面最上面的距离
  const MAX_SCROLL_TOP = window.document.body.scrollHeight - window.document.body.clientHeight

  setTimeout(function () {
    let currentY = document.documentElement.scrollTop || document.body.scrollTop
    let step = 10 // 步长系数 即剩余的距离除以40 每1ms 移动一段距离
    if (tarY > currentY) { // tarY > currentY 即向下滚动
      let dist = Math.ceil((tarY - currentY) / step)
      let nextY = currentY + dist
      if (nextY < tarY) { // 向上滚动和向下滚动判定的区别 是这里
        if (MAX_SCROLL_TOP < nextY) {
          window.scrollTo(0, MAX_SCROLL_TOP)
        } else {
          window.scrollTo(0, nextY)
          scrollTo(tarY)
        }
      } else {
        window.scrollTo(0, tarY)
      }
    } else {
      let dist = Math.floor((tarY - currentY) / step)
      let nextY = currentY + dist
      if (nextY > tarY) {
        window.scrollTo(0, nextY)
        scrollTo(tarY)
      } else {
        window.scrollTo(0, tarY)
      }
    }
  }, 16)
}



// WEBPACK FOOTER //
// ./src/components/utils.js